export default [
    {
        name: 'SelectTool',
        displayName: 'Select',
        icon: 'fas fa-hand-pointer',
        tooltip: 'Select - Click a feature to select it',
        mode: 'simple_select',
    },
    {
        name: 'CreateTool',
        displayName: 'Create',
        fontSize: '0.5rem',
        icon: 'fas fa-pencil',
        tooltip: 'Create Tool - Create a geo record',
        mode: 'draw_point',
    },
    {
        name: 'FeatureAreaTool',
        displayName: 'Feature Area',
        icon: 'fas fa-chart-area',
        tooltip: 'Feature Area - Measure areas of the features on your course',
        mode: 'simple_select',
    },
    {
        name: 'MeasureTool',
        displayName: 'Measure',
        icon: 'fas fa-ruler',
        tooltip: 'Ruler Tool - Measure distances',
        mode: 'MeasureLineStringMode',
    },
    {
        name: 'DuplicateTool',
        displayName: 'Duplicate',
        icon: 'fas fa-copy',
        tooltip: `Duplicate Tool - Click a feature and click a new location to duplicate it there by it's centre`,
        mode: 'simple_select',
    },
    {
        name: 'SmoothTool',
        displayName: 'Smooth',
        icon: 'far fa-wave-sine',
        tooltip:
            'Smooth Tool - Click a feature to smooth the dimension of that feature',
        mode: 'simple_select',
    },
];
